// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"492e6b75","857":"44f4b707","977":"459ae33c"}[chunkId] + ".chunk.js";
};